import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

/**
 * Shared dark hero band used at the top of every content page,
 * matching the pattern established on ArticlesPage/CommunityPage/ToolsPage.
 */
const PageHero = ({ eyebrow, title, description, children, testId, backTo, backLabel }) => {
  return (
    <section className="bg-chassis text-white py-16 md:py-24" data-testid={testId}>
      <div className="max-w-screen-2xl mx-auto px-4 md:px-8">
        <div className="max-w-3xl">
          {backTo && (
            <Link
              to={backTo}
              className="inline-flex items-center gap-2 text-white/60 hover:text-white transition-colors text-sm mb-6"
              data-testid="page-hero-back-link"
            >
              <ArrowLeft className="h-4 w-4" />
              {backLabel || 'Back'}
            </Link>
          )}
          {eyebrow && (
            <p className="font-mono text-xs tracking-widest text-autoxium-blue uppercase mb-4">
              {eyebrow}
            </p>
          )}
          <h1 className="font-chivo text-4xl md:text-6xl font-black uppercase tracking-tighter mb-6">
            {title}
          </h1>
          {description && (
            <p className="text-lg text-white/70 max-w-xl leading-relaxed">
              {description}
            </p>
          )}
          {children}
        </div>
      </div>
    </section>
  );
};

export default PageHero;
